import { LocalStorage } from './local-storage';
// Increment, Get a Message Id.  Set the Message Id.

export function getMessageId(): number {
  const newNumber = Number(LocalStorage.messageId()) + 1;
  LocalStorage.setMessageId(newNumber.toString());
  return newNumber;
}

export function setMessageId(): void {
  LocalStorage.setMessageId('0');
}
